export default {
    papers: [],
    certificates: [],
    coatingTypes: [],
    papersLoading: false,
    uploadCancelTokens: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        isVisible: true,
        name: null,
        group_id: null
    }
}